"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromPromise = undefined;

var _PromiseObservable = require("./PromiseObservable");

var fromPromise = exports.fromPromise = _PromiseObservable.PromiseObservable.create;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/rxjs/static-5.4/observable/fromPromise.js
// module id = 435
// module chunks = 177